const DEFAULT_SIZE = 40;

function getClusterFontSize(count, scale) {
  const base = count >= 100 ? 10 : count >= 10 ? 12 : 14;
  return base * scale;
}

/**
 * Build a sharp cluster marker icon via canvas at device pixel ratio.
 * Avoids Google Maps label rasterization, which looks blurry on retina displays.
 */
export function getClusterMarkerIcon(count, options = {}) {
  const {
    size = DEFAULT_SIZE,
    fill = '#1976d2',
    stroke = '#ffffff',
    textColor = '#ffffff',
  } = options;

  const scale = Math.max(2, Math.ceil(window.devicePixelRatio || 1));
  const canvas = document.createElement('canvas');
  canvas.width = size * scale;
  canvas.height = size * scale;

  const ctx = canvas.getContext('2d');
  const center = (size * scale) / 2;
  const radius = (size / 2 - 2) * scale;

  ctx.beginPath();
  ctx.arc(center, center, radius - scale, 0, Math.PI * 2);
  ctx.fillStyle = fill;
  ctx.fill();
  ctx.strokeStyle = stroke;
  ctx.lineWidth = 2 * scale;
  ctx.stroke();

  ctx.fillStyle = textColor;
  ctx.font = `700 ${getClusterFontSize(count, scale)}px Arial, Helvetica, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(String(count), center, center);

  const google = window.google.maps;
  return {
    url: canvas.toDataURL('image/png'),
    scaledSize: new google.Size(size, size),
    anchor: new google.Point(size / 2, size / 2),
  };
}

/** @returns {google.maps.Marker} */
export function createClusterMarker(count, position, options = {}) {
  return new window.google.maps.Marker({
    position,
    icon: getClusterMarkerIcon(count, options),
    zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
  });
}
